'use strict';

const overviewWidget = {
  bindings: {
    data: '<'
  },
  require: {
    overview: '^^overview'
  },
  template: `
    <table>
      <thead>
        <tr>
          <th colspan="3" ng-bind-html="$ctrl.data.name"></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="item in $ctrl.data.items track by $index">
          <td>{{ item.count }}</td>
          <td ng-if="item._links.self.uri === '/offer/open'">
            <a href="#/tilbud">{{ item.description }}</a>
          </td>
          <td ng-if="item._links.self.uri === '/order-confirmation/sent'">
            <a href="#/ordrebekreftelse">{{ item.description }}</a>
          </td>
          <td ng-if="item._links.self.uri !== '/offer/open' && item._links.self.uri != '/order-confirmation/sent'">
            <a href ng-click="$ctrl.overview.select(item._links.self.uri)">{{ item.description }}</a>
          </td>
          <td class="nowrap right-align">{{ item.total | crowns }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="2">Sum</th>
          <th class="nowrap right-align">{{ $ctrl.data.summary.total | crowns }}</th>
        </tr>
      </tfoot>
    </table>
  `
};

angular
  .module('SendRegning')
  .component('overviewWidget', overviewWidget);
